module.exports = __webpack_public_path__ + "static/img/aboutReyzarPic.bd5cce4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/aboutReyzarPic.jpg?011801
// module id = 3WLJ
// module chunks = 0